<template>
  <div class="min-h-screen flex items-center justify-center bg-gray-600">
    <nav
      class="fixed w-full top-0 z-10 flex items-center justify-between h-16 px-3 py-3 mb-4 bg-gray-700 print:hidden"
    >
      <div class="flex-1">
        <router-link :to="'/'">
          <logo></logo>
        </router-link>
      </div>
    </nav>
    <div class="bg-gray-800 rounded-lg" v-if="!subscriptionOk">
      <div class="max-w-screen-xl mx-auto py-12 px-4 sm:px-6">
        <div class>
          <h2
            class="text-3xl leading-9 font-extrabold tracking-tight text-white sm:text-4xl sm:leading-10"
            id="newsletter-headline"
          >
            {{ $t("newsletter.title") }}
          </h2>
          <p class="mt-3 max-w-3xl text-lg leading-6 text-gray-300">
            {{ $t("newsletter.text") }}
            <router-link :to="'/'">
              <span class="font-semibold">mi</span>
              <span class="text-blue-500 font-semibold">Curriculum</span>.
            </router-link>
          </p>
        </div>
        <div class="mt-8">
          <form class="sm:flex" aria-labelledby="newsletter-headline">
            <input
              aria-label="Email address"
              type="email"
              required
              class="appearance-none w-full px-5 py-3 border border-transparent text-base leading-6 rounded-md text-gray-900 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 transition duration-150 ease-in-out sm:max-w-xs"
              :placeholder="$t('newsletter.input_placeholder')"
              v-model="email"
            />
            <div
              class="mt-3 rounded-md shadow sm:mt-0 sm:ml-3 sm:flex-shrink-0"
            >
              <button
                @click.prevent="onSub"
                class="w-full flex items-center justify-center px-5 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-blue-500 hover:bg-blue-400 focus:outline-none focus:bg-blue-400 transition duration-150 ease-in-out"
              >
                {{ $t("newsletter.actionButton") }}
              </button>
            </div>
          </form>
          <router-link :to="'/'">
            <p
              class="w-full text-left mt-5 underline text-gray-500 hover:text-gray-400 text-sm font-medium tracking-wide"
            >
              {{ $t("newsletter.backButton") }}
            </p>
          </router-link>
          <!-- <p class="mt-3 text-sm leading-5 text-gray-300">
            We care about the protection of your data. Read our
            <a
              href="#"
              class="text-white font-medium underline"
            >Privacy Policy.</a>
          </p>-->
        </div>
      </div>
    </div>
    <div v-else class="flex flex-col justify-center items-center">
      <div class="text-center">
        <h2
          class="text-2xl tracking-tight leading-10 font-extrabold text-gray-100 sm:text-5xl sm:leading-none md:text-6xl"
        >
          <span class="text-blue-400">{{
            $t("newsletter.subscription_ok")
          }}</span>
          {{ $t("newsletter.subscription_ok_text") }}
        </h2>
      </div>
      <img
        src="@/assets/mail_sent2.svg"
        class="md:w-72 w-40 mt-8"
        alt="email_ok"
      />
      <router-link
        :to="'/'"
        class="text-blue-400 underline font-semibold text-sm mt-2"
        >{{ $t("newsletter.backButton") }}</router-link
      >
    </div>
    <div
      class="fixed inset-0 bg-gray-200 w-full flex justify-center items-center opacity-50"
      v-show="loading"
    >
      <div
        class="loader ease-linear rounded-full border-8 border-t-8 border-gray-200 h-64 w-64"
      ></div>
    </div>
  </div>
</template>

<script>
import Logo from "@/components/Logo";
import axios from "axios";

export default {
  components: {
    Logo,
  },
  data() {
    return {
      email: "",
      subscriptionOk: false,
      loading: false,
    };
  },
  methods: {
    async onSub() {
      if (this.email) {
        this.loading = true;
        try {
          const res = await axios({
            // headers: {
            //   "Content-Type": "application/json",
            //   Accept: "application/json",
            // },
            method: "post",
            url: "https://micurriculum.uy/.netlify/functions/subscription", //change region (us19) based on last values of ListId.
            data: {
              email: this.email,
            },
          });
          this.loading = false;
          if (res) {
            this.subscriptionOk = true;
          }
        } catch (error) {
          this.loading = false;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.loader {
  border-top-color: #5b9de8;
  -webkit-animation: spinner 1.5s linear infinite;
  animation: spinner 1.5s linear infinite;
}

@-webkit-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spinner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>